import { render, staticRenderFns } from "./Base64File.vue?vue&type=template&id=2983d559&scoped=true"
import script from "./Base64File.vue?vue&type=script&lang=js"
export * from "./Base64File.vue?vue&type=script&lang=js"
import style0 from "./Base64File.vue?vue&type=style&index=0&id=2983d559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983d559",
  null
  
)

export default component.exports